export default __webpack_public_path__ + "static/media/eggs.63079b09.jpg";